import mixpanel from "mixpanel-browser"

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
    debug: process.env.NODE_ENV !== "production",
    track_pageview: true,
    persistence: "localStorage",
    record_sessions_percent: 100,
    record_heatmap_data: true,
    api_host: "https://api-eu.mixpanel.com"
})

export const Mixpanel = {
    track: (name, props) => mixpanel.track(name, props),
    identify: (id, userProperties = {}) => {
        mixpanel.identify(id)
        if (Object.keys(userProperties).length > 0) {
            mixpanel.people.set(userProperties)
        }
    },
    identify_guest: (userData) => {
        const guestId = `guest_${userData.email || userData.phonenumber}`;
        mixpanel.identify(guestId);
        mixpanel.people.set({
            '$email': userData.email,
            '$phone': userData.phonenumber,
            'first_name': userData.firstname,
            'last_name': userData.lastname,
            'user_type': 'guest',
            'signup_date': new Date().toISOString(),
            'delivery_state': userData.state,
            'delivery_city': userData.city
        });
    },
    identify_user: (userData) => {
        mixpanel.identify(userData.id);
        mixpanel.people.set({
            '$email': userData.email,
            '$phone': userData.phone,
            '$name': `${userData.firstName} ${userData.lastName}`,
            'first_name': userData.firstName,
            'last_name': userData.lastName,
            'user_type': 'registered',
            'signup_date': userData.createdAt,
            'last_login': new Date().toISOString()
        });
    },
    reset: () => {
        mixpanel.reset();
    },
    alias: (id) => mixpanel.alias(id),
    track_home_add_to_cart: ({ split_buy_id, screen, split_buy_name, additionalProps = {} }) => {
        mixpanel.track('Tap-HomeScreen-AddToCartButton', {
            screen: screen ?? 'HomeScreen',
            split_buy_id: split_buy_id,
            split_buy_name: split_buy_name,
            timestamp: new Date().toISOString(), ...additionalProps
        });
    },
    track_home_remove_from_cart: ({ split_buy_id, split_buy_name, additionalProps = {} }) => {
        mixpanel.track('Tap-HomeScreen-RemoveFromCartButton', {
            screen: 'HomeScreen',
            split_buy_id: split_buy_id,
            split_buy_name: split_buy_name,
            timestamp: new Date().toISOString(), ...additionalProps
        });
    },
    track_split_buy_add_to_cart: ({ id, name, status, joined_status,
        reserved_slot, slots_left,
        split_buy_location,
        date_remaining, cost_per_split }) => {
        mixpanel.track('Tap-AddToCart-SplitBuyButton', {
            id, name, status, joined_status, reserved_slot, slots_left, split_buy_location,
            date_remaining, cost_per_split,
            timestamp: new Date().toISOString()
        });
    },
    track_split_buy_remove_from_cart: ({ id, name, status, joined_status,
        reserved_slot, slots_left,
        split_buy_location,
        date_remaining, cost_per_split }) => {
        mixpanel.track('Tap-SplitBuyScreen-RemoveFromCartButton', {
            id, name, status, joined_status, reserved_slot, slots_left, split_buy_location,
            date_remaining, cost_per_split,
            timestamp: new Date().toISOString()
        });
    },
    track_view_cart_screen: (number_of_split_buys_in_cart) => {
        mixpanel.track('View-CartScreen', {
            number_of_split_buys_in_cart, timestamp: new Date().toISOString(),
        })
    },
    track_cart_screen_select_split_buy_checkbox: ({ split_buy_id, split_buy_name }) => {
        mixpanel.track('Tap-CartScreen-SelectSplitBuyCheckbox', {
            split_buy_id, split_buy_name, timestamp: new Date().toISOString(),
        })
    },
    track_cart_screen_proceed_checkout: ({ split_buy_ids }) => {
        mixpanel.track('Tap-CartScreen-ProceedToCheckoutButton', {
            split_buy_ids, timestamp: new Date().toISOString(),
        })
    },
    track_delivery_address_checkout_button: ({ split_buy_ids, is_pickup, delivery_address_state }) => {
        mixpanel.track('Tap-DeliveryAddressScreen-CheckoutButton', {
            split_buy_ids, is_pickup, delivery_address_state, timestamp: new Date().toISOString(),

        })
    },
    track_address_screen_address_added: (state) => {
        mixpanel.track('Generic-AddressesScreen-AddressAdded', {
            state, timestamp: new Date().toISOString(),
        })
    },
    track_address_screen_address_removed: (state) => {
        mixpanel.track('Generic-AddressesScreen-AddressRemoved', {
            state, timestamp: new Date().toISOString(),
        })
    },
    track_success_contact_form_submitted: ({firstName, lastName, mobile, email, message}) => {
        mixpanel.track('Success-ContactUsFormSubmitted', {
            firstName, lastName, mobile, email, message,
            timestamp: new Date().toISOString(),
        })
    },
    track_failed_contact_form_submitted: ({firstName, lastName, mobile, email, message}) => {
        mixpanel.track('Failed-ContactUsFormSubmitted', {
            firstName, lastName, mobile, email, message,
            timestamp: new Date().toISOString(),
        })
    },
    track_success_b2b_price_request_submitted: (event) => {
        mixpanel.track('Success-B2BPriceRequestModalSubmitted', {
            ...event,
            timestamp: new Date().toISOString(),
        })
    },
    track_failed_b2b_price_request_submitted: (event) => {
        mixpanel.track('Failed-B2BPriceRequestModalSubmitted', {
            ...event,
            timestamp: new Date().toISOString(),
        })
    },
    people: {
        set: (props) => mixpanel.people.set(props), increment: (props) => mixpanel.people.increment(props),
    },
}